// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","667":"3fde8ab8","977":"9cfa6e4f"}[chunkId] + ".chunk.js";
};